export default __webpack_public_path__ + "static/media/hero2.1cb36d4c.png";